
import { fns, libTypes } from "@holta/lib";
import { useStore } from "../../config/store";
import { getEditOrder } from "./getEditOrder";
import {create} from 'mutative';

export const setOrderValueEstimate = (orderValueEstimate: libTypes.Order['orderValueEstimate']) => {

    const editOrder = getEditOrder();

    useStore.setState({
        editOrder : create(editOrder, draft => {
            draft.newValues.order.orderValueEstimate = fns.order.set.orderValueEstimate(orderValueEstimate);
        })
    });
};